import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    resources: 'Ресурсы',
    explore: 'Исследовать',
    skills: 'Скиллы',
    soon: 'скоро',
    notEnough: 'Не хватает?',
    buy: 'Купить',
    settings: 'Настройки',
    signOut: 'Выход',
    balance: 'Баланс',
    held: (amount: string) => `заморожено ${amount}`,
    creditsLeftShare: (percent: number) => `Осталось ${percent}% от последней покупки`,
    myCourses: 'Мои курсы',
    myArticles: 'Мои инструкции',
    newCourse: 'Создать курс',
    courseStats: 'Статистика',
    courseSettings: 'Настройки',
    newArticle: 'Создать статью',
    language: 'Язык',
    recent: 'Недавние',
    noCourses: 'Нет курсов',
    openNavigation: 'Открыть навигацию',
  },
  en: {
    resources: 'Resources',
    explore: 'Explore',
    skills: 'Skills',
    soon: 'Soon',
    notEnough: 'Need more?',
    buy: 'Buy',
    settings: 'Settings',
    signOut: 'Sign out',
    balance: 'Balance',
    held: (amount: string) => `${amount} on hold`,
    creditsLeftShare: (percent: number) => `${percent}% of your last purchase left`,
    myCourses: 'My courses',
    myArticles: 'My articles',
    newCourse: 'Create course',
    courseStats: 'Statistics',
    courseSettings: 'Settings',
    newArticle: 'Create article',
    language: 'Language',
    recent: 'Recent',
    noCourses: 'No courses',
    openNavigation: 'Open navigation',
  },
})
